import { render, staticRenderFns } from "./fifthBlogRow.vue?vue&type=template&id=5454b85c&"
import script from "./fifthBlogRow.vue?vue&type=script&lang=js&"
export * from "./fifthBlogRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports